module.exports = __webpack_public_path__ + "img/snowy.3def7c9f.svg";